import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const SiteSettingsContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    logo_url: null,
    favicon_url: null,
    footer_email: "info@noleggiofurgoni.it",
    footer_phone: "800 123 456",
    footer_address: "",
    footer_city: "Italia",
    social_facebook: "",
    social_instagram: "",
    social_linkedin: ""
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get(`${API}/site-settings/public`);
      if (res.data) {
        setSettings(prev => ({
          ...prev,
          ...res.data
        }));
        
        // Update favicon dynamically if set
        if (res.data.favicon_url) {
          const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = res.data.favicon_url;
          document.getElementsByTagName('head')[0].appendChild(link);
        }
      }
    } catch (error) {
      console.log("Using default site settings");
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    return {
      settings: {
        logo_url: null,
        favicon_url: null,
        footer_email: "info@noleggiofurgoni.it",
        footer_phone: "800 123 456",
        footer_address: "",
        footer_city: "Italia",
        social_facebook: "",
        social_instagram: "",
        social_linkedin: ""
      },
      loading: false,
      refreshSettings: () => {}
    };
  }
  return context;
}
